<template>
  <div
    v-if="currentSong"
    id="media-player"
    class="w-full fixed bottom-0 top-auto bg-smokegray z-40"
  >
    <!-- <audio>
        <source :src="audioSource" type="audio/mpeg">Nem támogatott böngésző! Kérjük frissítsd a böngésződet!
      </audio> -->
    <div class="w-full max-w-7xl md:max-w-lg lg:max-w-6xl 2xl:max-w-7xl mx-auto flex flex-col lg:flex-row gap-x-6">
      <div class="w-full flex">
        <a
          class=" m-[5px]  lg:ml-[25px] md:my-[5px] 2xl:my-[15px] "
          @click="toggleStatus"
        >
          <!-- !isPlaying, -->
          <img
            v-if="!isPlaying"
            src="/img/radio_play_icon.svg"
            class="w-[45px] h-[45px]"
            alt=""
          > 
          <img
            v-else 
            src="/img/radio_stop_icon.svg"
            class="w-[45px] h-[45px]"
            alt=""
          >
        
        </a>
        <RePictureSet
          v-if="currentSong.album && currentSong.album.thumbnail"
          :key="currentSong.id + '_' + currentSong.slug"
          :image="currentSong.album.thumbnail"
          image-class=" lazyload"
          sizes="50px"
          class="hidden lg:!inline-block my-auto  mx-[15px] max-h-[50px] max-w-[50px]"
        />
        <div class="media-player__scrolling-title-box lg:max-w-5xl  my-auto">
          <div
            :class="{'scrolling-title-mobile':currentSong.title.length>45,'scrolling-title':currentSong.title.length>90
            }"
          >
            <nuxt-link
              :to="
                '/mediatar/felvetelek/' + currentSong.id + '/' + currentSong.slug
              "
              class=""
            >
              <span class="text-white font-source-serif-pro text-base lg:text-xl font-bold">{{ currentSong.title }} 
                <!-- Kutya, macska, vadászgörény, egyéb kisebb háziállatok biztonságos szállítása Írországra és Anglia egyes részeire szabva  -->
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>
      <div class="hidden lg:!inline-block mx-4 my-auto text-center pt-3 lg:pt-0">
        <nuxt-link
          to="/radio/musorujsag"
          class="text-white font-semibold underline text-lg lg:text-xl"
        >
          Műsor
        </nuxt-link>
      </div>
      <div class="hidden lg:!inline-block media-player__volume-container my-auto">
        <input
          v-model="volume"
          type="range"
          min="0"
          max="10"
          step="0.5"
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
const STATUSES = { STOPPED: 0, PAUSED: 1, PLAYING: 2 };
export default {
  components: {
    RePictureSet
  },
  props: {
    // eslint-disable-next-line
    currentSong: {
      default: null,
      validation: prop => {
        return prop instanceof Object || prop === null;
      },
      required: true
    },
    value: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      active: false,
      audioElement: null,
      status: STATUSES.STOPPED,
      duration: "0:00",
      volume: 5,
      progress: 0,
      audioSource: process.env.NODE_ENV === "production" ? "https://stream.folkradio.hu/folkradio.mp3" : "https://folktest.folkradio.hu/radio/8000/folkradio.mp3"
    };
  },
  computed: {
    ...mapState(['isRadioPlaying']),
    isMoving(){
     var box = document.getElementsByClassName("font-title");
     console.log("ertek")
     console.log(box.innerHTML().length())
    return box.innerHTML().length()>250

    },
    isPaused() {
      return STATUSES.PAUSED === this.status;
    },
    isPlaying() {
      return STATUSES.PLAYING === this.status;
    },
    currentSongRegions() {
      if (this.currentSong) {
        let regions = "";
        for (let i = 0; i < this.currentSong.regions.length; i++) {
          regions += this.currentSong.regions[0].name + ",";
        }
        return regions.replace(/(^,)|(,$)/g, "");
      }

      return "";
    }
  },
  watch: {
    isRadioPlaying(newValue, oldValue) {
      if(newValue !== oldValue){
        if(newValue && this.status !== STATUSES.PLAYING){
          this.toggleStatus()
        } else if(!newValue && this.status !== STATUSES.PAUSED) {
          this.toggleStatus()
        }
      }
    },
    volume() {
      this.updateVolume();
    },
    currentSong: function handler() {
      this.$forceUpdate()
    },
    deep: true
  },
  created() {
    const url = this.$axios.defaults.baseURL;
    if (url.includes("test")) {
      this.audioSource = "http://folktest.folkradio.hu:8000/folkradio.mp3";
    }
  },
  methods: {
    toggleStatus() {
      if (!this.isPlaying) {
        if (!this.audioElement) {
          this.audioElement = new Audio(this.audioSource);
        }
        this.updateVolume();
        this.status = STATUSES.STOPPED;
        this.play();
      } else {
        this.pause();
      }
    },
    play() {
      this.status = STATUSES.PLAYING;
      this.$emit("input", true);
      const src = this.audioElement.src;
      this.audioElement.src = "";
      this.audioElement.src = src;
      this.audioElement.play();
      this.$store.commit('setIsRadioPlaying',  true)
    },
    pause() {
      this.$emit("input", false);
      this.status = STATUSES.PAUSED;
      this.audioElement.pause();
      this.$store.commit('setIsRadioPlaying', false)
    },
    updateVolume() {
      this.audioElement.volume = this.volume / 10;
    }
  }
};
</script>
<style lang="scss" scoped>


.media-player {
  &__controls {
    width: 100%;
    border-radius: 6px;
    // background-color: #353b48;

    position: relative;
    display: flex;
  }
  &__play-pause-button {
    cursor: pointer;
    display: inline-block;
    font-size: 40px;
    color: #fff;
    width: 40px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border-radius: 50%;
  }
  &__play-pause-button:hover {
    color: 000;
  }
  &__info {
    a {
      color: white;
      &:hover {
        color: 000;
      }
    }

    color: #fff;
    position: relative;
    display: flex;
    align-items: center;
    left: 65px;
    img {
      height: 40px !important;
      width: auto !important;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
  &__now-playing {
    white-space: nowrap;
  }

  &__scrolling-title-box {

    height: 25px;
    width: 100%;
    overflow: hidden;
    margin-left: 10px;
    // max-width: 500px;
    & .scrolling-title {
        animation: slide-right 30s forwards;
         animation-timing-function: linear;
       animation-iteration-count: infinite;
       width: max-content;
    }
  }
 

  &__volume-container input {
    -webkit-appearance: none;
    width: 100%;
    height: 3px;
    border-radius: 5px;
    background-color: #fff;
    outline: none;
    transition: opacity 0.2s;
  }
  &__volume-container input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background: #F9A72D;
    cursor: pointer;
  }
  &__volume-container input::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background: #F9A72D;
    cursor: pointer;
    border: none;
  }
  &__playback-container {
    height: 10px;
    width: 100%;
    border-radius: 20px;
    position: relative;
    background-color: #7f8fa6;
    margin-top: 40px;
  }
  &__playback-container div {
    background-color: #fff;
    border-radius: 6px;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
  &__playback-container .duration {
    position: absolute;
    top: -16px;
    right: 0;
    font-size: 12px;
  }
}
.hidden{
  display: none;
}
@keyframes slide-right {
  0%{
      transform:translateX(0);
  }
  30% {
    transform:translateX(0);
  }
  100% {
    
    transform:translateX(-100%);
  }
  
  
}
@media only screen and (max-width: 768px) {

  .scrolling-title-mobile {
    width: 80vw;
     animation: slide-right 30s forwards;
         animation-timing-function: linear;
       animation-iteration-count: infinite;
       width: max-content;

    .font-title {
      top: 0;
      width: 300%;
      max-width: 80vw;
    }
  }
  .media-player {
    &__play-pause-button {
      font-size: 25px;
      width: 25px;
      height: 35px;
    }
    &__info {
      font-size: 14px;
      top: -2px;
      left: 15px;
      flex-wrap: wrap;
    }
    &__scrolling-title {
      position: relative;
      height: 18px;
      padding-left: 0;
      flex-basis: 100%;
      flex-grow: 4;
    }
  }
}
</style>
